import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    name: Yup.string().required("Name is required"),
    projectTypeId: Yup.string().nullable().required("Project Type is required"),
    description: Yup.string()
});